import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { motion } from "framer-motion";
import Footer from "./footer";
import LatestUpdates from "./latestupdates";

function LatestUpdatesSection({ title, updates }) {
    return (
        <div className="container-fluid py-5">
            <div className="container">
                <h2 className="text-center mb-3">{title}</h2>
                <div className="row g-4">
                    {updates.map((update, index) => (
                        <div className="col-12 col-md-6 col-lg-4" key={index}>
                            <div className="card shadow-sm border-0 h-100">
                                <img src={update.img} className="card-img-top" alt={update.alt} style={{ height: "140px", objectFit: "cover" }} />
                                <div className="badge bg-secondary position-absolute m-2">{update.badge}</div>
                                <div className="card-body d-flex flex-column">
                                    <h5 className="card-title text-primary">{update.title}</h5>
                                    <p className="card-text flex-grow-1">{update.description}</p>
                                    <Link to={update.link} className="text-primary">READ MORE &rarr;</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
        </div>
    );
}

function LatestUpdatess() {
    const sections = [
        {
           
            updates: [
                { img: "./img/professional.jpg", alt: "Professional Year",  title: "Professional Year", description: "A professional development program involving formal learning.", link: "/professional" },
                { img: "./img/course-change.jpg", alt: "Course Change", title: "Admissions And Course Change", description: "Take admission or change the course.", link: "/coursechange" },
            ],
        },
        {
           
            updates: [
                { img: "./img/skilled-id.png", alt: "Skilled Visa",  title: "Skilled Independent Visa (189)", description: "A visa for skilled workers.", link: "/skilledID" },
                { img: "./img/skilled-work.png", alt: "Work Visa", title: "Skilled Work Regional Visa (491)", description: "Work in specific regions.", link: "/workregionalvisa" },
            ],
        },
        {
           
            updates: [
                { img: "./img/skilled-id1.png", alt: "Nominated Visa",  title: "Skilled Nominated Visa (Subclass 190)", description: "A visa for skilled workers.", link: "/nominatedvisa" },
                { img: "./img/skilled-work1.png", alt: "Regional Visa",  title: "Skilled Regional Visa (Subclass 887)", description: "Work in specific regions.", link: "/skilledregional" },
            ],
        },
        {
           
            updates: [
                { img: "./img/temp-activity.png", alt: "Temporary Activity Visa",  title: "Temporary Activity Visa (408)", description: "Short-term activity visa.", link: "/tempactivity" },
                { img: "./img/temp-graduate.png", alt: "Graduate Visa",  title: "Temporary Graduate Visa (485)", description: "Post-study work visa.", link: "/temporarygraduate" },
            ],
        },
        {
            
            updates: [
                { img: "./img/skill-shortage.png", alt: "Skill Shortage",  title: "Temporary Skill Shortage Visa (482)", description: "Work for a short period.", link: "/tempskillshortage" },
                { img: "./img/visitor.jpg", alt: "Visitor Visa",  title: "Visitor Visa", description: "Visit for leisure or business.", link: "/visitorvisa" },
            ],
        },
    ];

    

    return (
        <>
            {sections.map((section, index) => (
                <LatestUpdatesSection key={index} title={section.title} updates={section.updates} />
            ))}
            <Button variant="danger" className="btn-sm position-fixed bottom-0 start-0 m-3">
               
            <a href="https://au.bajwaimmigration.com/book-appointment" > Book Appointment</a>
            </Button>
            <LatestUpdates/>
            <Footer/>
        </>
    );
}

export default LatestUpdatess;
